import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { getMessage } from 'util/locale';

// constants
import { scriptConfigViews } from 'constants/values';

// components
import { Icon } from '@tcc/crate';
import BaseTrigger from 'triggers/BaseTrigger';

const baseString = 'vra-script-config-view-trigger';
const ScriptConfigViewTrigger = ({
  currentView,
  onClick
}) => {
  const classString = classNames({
    [`${baseString}`]: true,
    [`${baseString}--${currentView}`]: !!currentView
  });
  const getButtonText = (currentView === scriptConfigViews.INPUTS) 
    ? getMessage(`button-text__script-config-view-inputs`)
    : getMessage(`title-text__script-config`);

  return (
    <section className={classString}>
      { currentView === scriptConfigViews.INPUTS && <Icon glyph={Icon.set.ARROW_BACK} />}
      <BaseTrigger
        className={`${baseString}__trigger`}
        content={getButtonText}
        dataTestId={baseString}
        handler={onClick}
      />
    </section>
  );
};

ScriptConfigViewTrigger.propTypes = {
  currentView: propTypes.string.isRequired,
  onClick: propTypes.func.isRequired
};
export default ScriptConfigViewTrigger;
